const MOJIBAKE_PATTERN = /(Á.|Â|â€|â€™|â€œ|â€|ðŸ|�)/;

const scoreTextQuality = (text = '') => {
  const value = String(text || '');
  if (!value.trim()) return -1000;

  let score = value.length;
  const replacementCount = (value.match(/�/g) || []).length;
  const mojibakeHits = (value.match(MOJIBAKE_PATTERN) || []).length;

  score -= replacementCount * 12;
  score -= mojibakeHits * 7;
  return score;
};

const decodeLatin1AsUtf8 = (value) => {
  const input = String(value || '');
  const bytes = Uint8Array.from(Array.from(input).map((char) => char.charCodeAt(0) & 0xff));
  return new TextDecoder('utf-8').decode(bytes);
};

export const repairMojibake = (value) => {
  if (value === null || value === undefined) return '';

  const source = String(value);
  if (!source.trim()) return source;

  const attempts = [source];

  try {
    attempts.push(decodeLatin1AsUtf8(source));
  } catch {
    // no-op
  }

  try {
    const prev = attempts[attempts.length - 1];
    attempts.push(decodeLatin1AsUtf8(prev));
  } catch {
    // no-op
  }

  return attempts.reduce((best, candidate) => {
    return scoreTextQuality(candidate) > scoreTextQuality(best) ? candidate : best;
  }, source);
};

export const safeUiText = (value, fallback = '') => {
  const normalized = repairMojibake(value)
    .replace(/\s{2,}/g, ' ')
    .trim();
  return normalized || fallback;
};

